import React from "react";
import ServiceHero from "./ServiceHero";
import ServiceArea from "./ServiceArea";
import ContactForm from "../../components/ContactForm";

const Service = () => {
  return (
    <>
      <ServiceHero />
      <ServiceArea />
      <ContactForm />
    </>
  );
};

export default Service;
